var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M20.667 10.083h-3.666l-2.75 8.25-5.5-16.5L6 10.083H2.334"
  })));
};
export { SvgActivity as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjMgMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIwLjY2NyAxMC4wODNoLTMuNjY2bC0yLjc1IDguMjUtNS41LTE2LjVMNiAxMC4wODNIMi4zMzQiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";